import { Equals, IsBoolean, IsOptional, IsString } from 'class-validator'

export class FarmAgroCharterSignatureForm {
  @IsBoolean()
  @Equals(true)
  acceptTerms!: boolean

  @IsString()
  farmSignature!: string

  @IsString()
  @IsOptional()
  bndSignature?: string
}
